import { render, staticRenderFns } from "./UserGroupTree.vue?vue&type=template&id=19313d5e&"
import script from "./UserGroupTree.vue?vue&type=script&lang=js&"
export * from "./UserGroupTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports